import React from 'react'

export const PageTemplate: React.FC = ({children}) => {
  return (
    <div className="ml-[218px] pt-[48px] pb-[114px] pr-[66px]">
      {children}
    </div>
  )
}
